export default "__VITE_PUBLIC_ASSET__36127b3f__"